@file:UseSerializers(BigDecimalSerializer::class)
@file:Suppress("unused")
@file:OptIn(DelicateCoroutinesApi::class, ExperimentalTime::class)

package net.sergeych.ugdx.shared.trader

import net.sergeych.ugdx.shared.BigDecimalSerializer
import kotlinx.coroutines.*
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import kotlin.math.abs
import kotlin.math.max
import kotlin.math.min
import kotlin.random.Random
import kotlin.time.Duration
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.minutes
import kotlin.time.Duration.Companion.seconds
import kotlin.time.ExperimentalTime

@Serializable
data class CandleStick(
    val open: Double?,
    val close: Double?,
    val min: Double?,
    val max: Double?,
    val baseVolume: Double=0.0,
    val quoteVolume: Double=0.0
) {
    internal val median = if( open != null && close != null ) (open + close) / 2 else null

    companion object {
        fun randomAround(value: Double, variation: Double = value * 0.07): CandleStick {
            val base = value + variation * Random.nextDouble(-1.0, 1.0)
            val change = variation * (Random.nextDouble() * 2 - 1)
            val absChange = abs(change)
            val open = base + change
            val end = base - change
            val mi = min(open, end)
            val ma = max(open, end)
            return CandleStick(
                open, end,
                mi - absChange * Random.nextDouble(),
                ma + absChange * Random.nextDouble(),
            )
        }
    }
}

@Serializable
data class CandleStickSeries(
    val currencyPair: CurrencyPair,
    val start: Instant,
    val intervalSeconds: Int,
    val sticks: List<CandleStick>,
)

enum class HistoryInterval(val duration: Duration) {
    /**
     * Realtime updates are normally not available for all clients, so do not show it as option
     * unless is explicitly supported by
     */
    REALTIME(1.seconds),
    FAST(1.minutes),
    MEDIUM(5.minutes),
    SLOW(10.minutes),
    HOURLY(1.hours),
    DAILY(24.hours)
}

/**
 * The dynamic event provided by the real-time flow bye [Trader.getFlow] like functions.
 */
data class CandleStickEvent(
    val currencyPair: CurrencyPair,
    val start: Instant,
    val interval: HistoryInterval,
    val stick: CandleStick,
)

